import React from 'react';
import { Form, Formik, Field, ErrorMessage } from 'formik';
import { connect, useDispatch } from 'react-redux';
import _ from 'lodash';
import axios from 'axios';
import { Button, FormText, Input } from 'reactstrap';
import * as Yup from 'yup';
import { doLogout } from '../../actions/login';
import { notEmpty } from '../../components/share/utils';
import { Password } from '../../components';

const Profile = ({ username = '', boName, toName, isBankStaff, loginUsername, changeUsername }) => {
  const [errorMessage, setErrorMessage] = React.useState('');
  const dispatch = useDispatch();

  const initialValues = {
    username,
    password: '',
    newPassword: '',
  };

  const onSubmit = async (values) => {
    try {
      await axios.post('/api/change-password', values);
      alert('Thành công!');
      dispatch(doLogout());
    } catch (error) {
      const { response } = error;
      if ('INVALID_CREDENTIAL' === response?.data?.message) {
        setErrorMessage('Mật khẩu không hợp lệ.');
      } else {
        setErrorMessage('Không thể thực hiện yêu cầu.');
      }
    }
  };

  const renderUsername = () => {
    if (!isBankStaff) return null;
    return (
      <Formik
        initialValues={{ newUsername: loginUsername }}
        validationSchema={Yup.object().shape({
          newUsername: Yup.string()
            .required('Chọn tên đăng nhập.')
            .matches(/^[a-zA-Z0-9_.]+$/, 'Tên đăng nhập không hợp lệ.'),
        })}
        onSubmit={async (values, helper) => {
          helper.setSubmitting(true);
          try {
            await axios.post('/api/change-username', values);
            changeUsername(values);
          } catch (err) {
            helper.setFieldError('newUsername', 'Tên đăng nhập không hợp lệ');
          } finally {
            helper.setSubmitting(false);
          }
        }}
        enableReinitialize
      >
        {(props) => (
          <Form>
            <div className='row'>
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>Tên đăng nhập</label>
                  <Field name='newUsername' as={Input} />
                  <ErrorMessage name='newUsername' component={FormText} color='danger' />
                  <Button
                    className='mt-2'
                    color='primary'
                    type='submit'
                    outline
                    disabled={!props.isValid || props.isSubmitting}
                  >
                    Cập nhật
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  return (
    <div className='container mt-5'>
      <fieldset>
        <legend>Đổi mật khẩu</legend>
        {errorMessage ? <span className='form-text text-danger'>{errorMessage}</span> : null}
        <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true}>
          {(props) => (
            <Form>
              <div className='row'>
                <div className='col-md-6'>
                  <Password name='password' label='Mật khẩu hiện tại' required validate={notEmpty} />
                </div>
                <div className='col-md-6'>&nbsp;</div>

                <div className='col-md-6'>
                  <Password name='newPassword' label='Mật khẩu mới' validate={notEmpty} required />
                </div>
              </div>
              <button className='btn btn-primary mt-3' disabled={props.isSubmitting || !props.isValid}>
                Cập nhật
              </button>
            </Form>
          )}
        </Formik>
      </fieldset>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  const changeUsername = (values) => (dispatch) => {
    dispatch({ type: 'CHANGE_USERNAME', payload: { ...values } });
  };

  return {
    changeUsername: (values) => dispatch(changeUsername(values)),
  };
};

const mapStateToProps = (state, props) => {
  const bo = state?.lookup?.bo || [];
  const boCode = state?.lookup?.profile?.boCode;
  const boName = _.find(bo, ['code', boCode])?.name || boCode;

  const to = state?.lookup?.to || [];
  const toCode = state?.lookup?.profile?.toCode;
  const toName = _.find(to, ['code', toCode])?.name || toCode;

  const username = state?.auth?.name;
  const loginUsername = state?.auth?.loginUsername || username;

  const isBankStaff = state?.auth?.isBankStaff;

  return { boName, toName, username, isBankStaff, loginUsername };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
